import React, {  useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import PlannedBudgetChart from "./PlannedBudgetChart";
import SpentBudgetChart from "./SpentBudgetChart";
import SectionHeading from "../SectionHeading";
import { PublicApi } from "api/api";
import { useTranslation } from "react-i18next"; 
import { formatCurrency } from "utility/index";
const publicApi = new PublicApi()

function RegionalData() {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [yearsList,setYearsList] = useState([]);
  const [plannedBudgetList,setPlannedBudgetList] = useState([]);
  const [totalPlannedBudget,setTotalPlannedBudget] = useState(0);
  const [totalSpentBudget,setTotalSpentBudget] = useState(0);
  const [spentBudgetList,setSpentBudgetList] = useState([]);
  const { t } = useTranslation();
  const handleSelect = (year) => {
    setSelectedYear(year);
    // getBudgetByYear(year)
  };

  const getBudgetByYear = async (year) => {
    const plannedBudgetResponse = await publicApi.apiPublicGetAllPlannedBudgetByCountry({year:year});
    setPlannedBudgetList(plannedBudgetResponse?.data?.budgets);
    setTotalPlannedBudget(plannedBudgetResponse?.data?.totalPlannedBudgetAllCountry)
    const spentBudgetResponse = await publicApi.apiPublicGetAllSpentBudgetByCountry({year:year});
    setSpentBudgetList(spentBudgetResponse?.data?.budgets);
    setTotalSpentBudget(spentBudgetResponse?.data?.totalSpentBudgetAllCountry)
  }

  const getAllYearsList = async () => {
    const response = await publicApi.apiPublicGetAllYearsList();
    setYearsList(response?.data?.yearsList)
  }

  useEffect(() => {
    getAllYearsList();
  },[]);

  useEffect(() => {
    getBudgetByYear(selectedYear)
  },[selectedYear])

  const chartData = [
    {
      title: `${t("home:regional:planned-budget","Total planned budget by Country")} (${selectedYear})`,
      countries : plannedBudgetList?.map((country,index) => {
        return {name : country?.countryName,image:`/images/png/planned-chart${index+1}.png`}
      }),
      // countries: [
      //   {
      //     name: "Bosnia and Herzegovina",
      //     image: "/images/png/planned-chart1.png",
      //   },
      //   { name: "Kosovo", image: "/images/png/planned-chart2.png" },
      //   { name: "Montenegro", image: "/images/png/planned-chart3.png" },
      //   { name: "North Macedonia", image: "/images/png/planned-chart4.png" },
      //   { name: "Serbia", image: "/images/png/planned-chart5.png" },
      // ],
      priceText : t("home:regional:planned-budget-price","Price of Plan Budget (Euro)"),
      price: formatCurrency(totalPlannedBudget),
      chartComponent: <PlannedBudgetChart data={plannedBudgetList} />,
    },
    {
      title: `${t("home:regional:spent-budget","Total spent budget by Country")} (${selectedYear})`,
      countries : spentBudgetList?.map((country,index) => {
        return {name : country?.countryName,image:`/images/png/spent-chart${index+1}.png`}
      }),
      // countries: [
      //   {
      //     name: "Bosnia and Herzegovina",
      //     image: "/images/png/spent-chart1.png",
      //   },
      //   { name: "Kosovo", image: "/images/png/spent-chart2.png" },
      //   { name: "Montenegro", image: "/images/png/spent-chart3.png" },
      //   { name: "North Macedonia", image: "/images/png/spent-chart4.png" },
      //   { name: "Serbia", image: "/images/png/spent-chart5.png" },
      // ],
      priceText : t("home:regional:spent-budget-price","Price of Spent Budget (Euro)"),
      price: formatCurrency(totalSpentBudget),
      chartComponent: <SpentBudgetChart data={spentBudgetList} />,
    },
  ];




  return  (
    <section className="regional-data">
    
      <SectionHeading title={t("home:regional-highlights","Regional key data highlights")} />
      <div className="dropdown-year">
      
        <h6>{t("home:regional:select-year","Select year")}</h6>
        <Dropdown>
          <Dropdown.Toggle id="dropdown-year">{selectedYear}</Dropdown.Toggle>
          <Dropdown.Menu>
            {yearsList.map((year) => (
              <Dropdown.Item
                key={year}
                onClick={() => handleSelect(year)}
                active={selectedYear === year}
              >
                {year}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {(spentBudgetList?.length > 0 && plannedBudgetList?.length > 0) && <div className="row gy-xl-0 gy-3">
        {chartData.map((card, index) => (
          <div className="col-xl-6" key={index}>
            <div className="chart-card">
              <h5 className="mb-md-5 mb-3">{card.title}</h5>
              <div className="d-sm-flex gap-xxl-5 gap-1 align-items-center">
                <div>{card.chartComponent}</div>
                <div className="mt-sm-0 mt-3">
                  <h5 className="mb-3">{t("home:regional:countries","Countries")}</h5>
                  <ul className="legends-group">
                    {card.countries.map((country, idx) => (
                      <li key={idx}>
                        <img src={country.image} alt={country.name} />
                        <span>{country.name}</span>
                      </li>
                    ))}
                  </ul>
                  <h5 className="mb-2">{card?.priceText}</h5>
                  <div className="d-flex align-items-center gap-2">
                    <img src="/images/svg/euro_sign.svg" alt="Dollar" />
                    <span>{card?.price?.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>}
    </section>
  ) ;
}

export default RegionalData;
